import { Link } from "react-router-dom";

function Tentang() {

    return (
        <div>

            <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow">

                <div className="container">

                    <Link
                        className="navbar-brand fw-bold"
                        to="/"
                    >
                        Rifhandi Portfolio
                    </Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div
                        className="collapse navbar-collapse"
                        id="navbarNav"
                    >

                        <ul className="navbar-nav ms-auto">

                            <li className="nav-item">
                                <Link
                                    className="nav-link active"
                                    to="/"
                                >
                                    Portfolio
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    className="nav-link"
                                    to="/tentang"
                                >
                                    Tentang
                                </Link>
                            </li>

                        </ul>

                    </div>

                </div>

            </nav>

            <div className="container py-5 ">

                <h1 className="fw-bold mb-4">
                    Tentang Saya
                </h1>

                <p className="lead">
                    Saya adalah seorang Fullstack Developer yang berfokus pada
                    pengembangan aplikasi web modern, scalable, dan siap digunakan
                    untuk kebutuhan bisnis maupun enterprise.

                    <br /><br />

                    Memiliki pengalaman dalam pengembangan backend menggunakan
                    PHP, Node.js, Java, dan MySQL, serta frontend modern dengan
                    React dan berbagai teknologi JavaScript lainnya.

                    <br /><br />

                    Saya juga berpengalaman dalam membangun arsitektur aplikasi
                    skala besar seperti microservices, REST API, Redis caching,
                    RabbitMQ message queue, Docker, Kubernetes, hingga monitoring
                    menggunakan OpenTelemetry.

                    <br /><br />

                    Selain pengembangan aplikasi, saya terbiasa menangani deployment
                    server, integrasi database, DevOps, autentikasi modern seperti
                    WebAuthn / Passkey, serta optimasi performa backend dan database.
                </p>

                <div className="mt-5">

                    <h3 className="fw-bold mb-4">
                        Layanan yang Saya Kerjakan
                    </h3>

                    <div className="row g-3 justify-content-center">

                        <div className="col-md-4">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body">
                                    Website Company Profile
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body">
                                    Sistem Management & Dashboard Admin
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body">
                                    REST API & Microservices
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body">
                                    Aplikasi ERP & CRM
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body">
                                    Integrasi Laravel, React, dan Node.js
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body">
                                    Docker & Kubernetes Deployment
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body">
                                    Redis, RabbitMQ, & Queue System
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body">
                                    Authentication JWT & Passkey
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body">
                                    Optimasi Backend & Database
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>


            <footer className="bg-dark text-light py-5">

                <div className="container text-center">

                    <h4 className="fw-bold mb-3">
                        Rifhandi
                    </h4>

                    <p className="text-muted">
                        Fullstack Developer • Backend • Frontend • Cloud
                    </p>

                    <div className="d-flex justify-content-center gap-3 flex-wrap mb-4">

                        <a
                            href="https://wa.me/6281927067602"
                            className="btn btn-success"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            WhatsApp
                        </a>

                        <a
                            href="https://github.com/muhammad-rifqi/"
                            className="btn btn-light"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            GitHub
                        </a>

                        <a
                            href="https://www.youtube.com/@muhammadrifqi9805"
                            className="btn btn-danger"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Youtube
                        </a>

                        <a
                            href="https://www.linkedin.com/in/muhammad-rifqy-004b47107"
                            className="btn btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            LinkedIn
                        </a>

                    </div>

                    <hr />

                    <p className="mb-0">
                        © 2026 Copyright by Rifhandi
                    </p>

                </div>

            </footer>


        </div>


    );
}

export default Tentang;